import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ShopContext } from '../context/shopcontext';
import {
  HomeIcon,
  ViewGridIcon,
  ShoppingCartIcon,
  ClipboardListIcon,
  HeartIcon,
} from '@heroicons/react/outline';
import { ChevronRight, ChevronLeft } from 'lucide-react';

const BottomNavbar = () => {
  const location = useLocation();
  const { token, navigate, getCartCount } = useContext(ShopContext);
  const [active, setActive] = useState(location.pathname);
  const [collapsed, setCollapsed] = useState(() => {
    const stored = sessionStorage.getItem('navbarCollapsed');
    return stored ? JSON.parse(stored) : false;
  });

  // Update active state when location changes
  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const toggleCollapse = () => {
    setCollapsed((prev) => {
      sessionStorage.setItem('navbarCollapsed', JSON.stringify(!prev));
      return !prev;
    });
  };

  const navItems = [
    { path: '/', icon: HomeIcon, label: 'Home' },
    { path: '/collection', icon: ViewGridIcon, label: 'Shop' },
    ...(token ? [{ path: '/orders', icon: ClipboardListIcon, label: 'Orders' }] : []),
    { path: '/wishlist', icon: HeartIcon, label: 'Wishlist' },
    { path: '/cart', icon: ShoppingCartIcon, label: 'Cart', hasCount: true },
  ];

  return (
    <div
      className={`fixed bottom-4 z-50 transition-all duration-300 ${
        collapsed ? 'right-0' : 'left-2 right-2'
      }`}
    >
      <div className={`flex ${collapsed ? 'justify-end' : 'justify-center'} relative`}>
        <div
          className={`h-16 flex items-center border border-[#b09287]/30 shadow-lg
            bg-gradient-to-r from-[#2a081a] via-[#2d161e] to-[#2a081a] backdrop-blur-lg backdrop-saturate-150 backdrop-brightness-110
            transition-all duration-300 overflow-hidden
            ${
              collapsed
                ? 'justify-end rounded-l-2xl rounded-tr-md rounded-br-md ml-auto'
                : 'w-full max-w-md justify-center rounded-3xl'
            }`}
        >
          {!collapsed && (
            <div className="flex-1 flex items-center justify-between px-6">
              {navItems.map(({ path, icon: Icon, label, hasCount }) => (
                <NavLink
                  key={path}
                  to={path}
                  onClick={() => handleNavigation(path)}
                  className={`text-[#ebe2db] hover:scale-110 transition !bg-transparent  p-2 rounded-full flex-shrink-0 flex flex-col items-center
                    ${
                      active === path
                        ? '[filter:drop-shadow(0_0_12px_rgba(235,226,219,0.8))] text-white '
                        : ''
                    }
                    hover:[filter:drop-shadow(0_0_8px_rgba(176,146,135,0.7))] hover:text-[#e0c3b5]`}
                >
                  <div className="relative">
                    <Icon className="w-6 h-6" />
                    {hasCount && (
                      <div className="absolute -top-2 -right-2 w-5 h-5 bg-gradient-to-br from-[#4c0f2e] to-[#2d161e] rounded-full flex items-center justify-center shadow-lg border-2 border-[#ebe2db]">
                        <span className="text-[8px] font-bold text-[#ebe2db]">
                          {getCartCount()}
                        </span>
                      </div>
                    )}
                  </div>
                  <span
                    className={`text-[8px] font-medium mt-1 transition-all duration-300 ${
                      active === path ? 'text-white font-semibold' : 'text-white/80'
                    }`}
                  >
                    {label}
                  </span>
                </NavLink>
              ))}
            </div>
          )}
          <div className="flex justify-center items-center">
            <button
              onClick={toggleCollapse}
              className="text-white p-1 rounded-sm transition [filter:drop-shadow(0_0_8px_rgba(255,255,255,0.5))] hover:[filter:drop-shadow(0_0_12px_rgba(255,255,255,0.7))]"
            >
              {collapsed ? <ChevronLeft size={18} /> : <ChevronRight size={18} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomNavbar;
